import { pushTo } from '@app/core/routing';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { VideoEditionPublishMenu } from '@app/modules/social-export/publish';

export interface CompositionVideoEditionPublishMenuProps {
  /** Video editor edit id; passed as `editId` query on the composition upload route for preselection. */
  editId: string;
  compositionId: string;
  /** Station of the composition; drives which social platforms are offered. */
  stationId: string | undefined;
  /**
   * When true, only a share icon opens the menu (used next to the “published on …” label on edit cards).
   */
  iconOnly?: boolean;
}

/**
 * "Publicar en" dropdown for a generated composition edit: lists station-connected platforms
 * and opens the composition upload wizard with this edit preselected (parity with fragment edit cards).
 */
export function CompositionVideoEditionPublishMenu({
  editId,
  compositionId,
  stationId,
  iconOnly = false,
}: CompositionVideoEditionPublishMenuProps) {
  return (
    <VideoEditionPublishMenu
      stationId={stationId}
      iconOnly={iconOnly}
      onSelectPlatform={(platformId) => {
        pushTo(composeRouteGenerator.upload(compositionId, platformId, editId));
      }}
    />
  );
}
